import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { get } from 'lodash'
import ClassNames from 'classnames'
import Typography from 'components/atoms/Typography/Typography'
import ReactHtmlParser from 'react-html-parser'
import SectionTitle from 'components/molecules/SectionTitle'
import { getRemoteVideo, userCheckMobileScreen } from 'helpers/tools'
import CustomModal from 'components/molecules/CustomModal/CustomModal'
import PlayIcon from 'assets/img/icone-play.svg'
import Slider from 'react-slick'

import './VideoGrid.scss'
import 'slick-carousel/slick/slick.css'

function VideoGrid({ data }) {
  const title = get(data, 'title')
  const description = get(data, 'description.value')
  const sectionTitle = get(data, 'section_title')
  const videos = get(data, 'items')
  // const isMobile = userCheckMobileScreen()
  const [isMobile, setIsMobile] = useState(true)
  const [isLoaded, setIsLoaded] = useState(false)
  const themeClasses = get(data, 'theme.entity.classes')
  const sectionBackgroundColor = get(data, 'secBackgroundColor.color')
  const [openImage, setOpenImage] = useState(false)
  const [stateVideoUrl, setStateVideoUrl] = useState('')
  const [stateVideoTitle, setStateVideoTitle] = useState('')

  useEffect(() => {
    setIsMobile(userCheckMobileScreen())
    setIsLoaded(() => true)
  }, [])

  const setting = {
    dots: true,
    dotsClass: 'slick-dots primary',
    infinite: false,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: false,
    centerPadding: '40px',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: false,
          focusOnSelect: true,
          useTransform: false,
        },
      },
    ],
  }

  function getVideoDataInfo(video) {
    const videoTitle = get(video, 'entity.title')
    const thumb = get(video, 'entity.thumb')
    const uuid = get(video, 'entity.uuid')
    const mediaEntity = get(video, 'entity.media.entity')
    const { entityBundle } = mediaEntity
    let thumbnail = null
    let alt = null

    const mediaEntities = {
      video: (media) => {
        const { fieldMediaVideoFile: { entity } } = media
        const { url: videoUrl } = entity
        const remoteThumb = 'https://placehold.co/480x360/008752/008752/'
        return { url: videoUrl, videoUrl, remoteThumb }
      },
      remote_video: (media) => {
        const { fieldMediaOembedVideo } = media
        const { url: videoUrl, thumb: remoteThumb } = getRemoteVideo(fieldMediaOembedVideo)
        return { url: fieldMediaOembedVideo, videoUrl, remoteThumb }
      }
    }

    if (thumb) {
      thumbnail = thumb?.entity?.images?.large?.url
      alt = thumb?.entity?.images?.alt
    }    

    const getMediaEntityData = mediaEntities[entityBundle]
    const { url, videoUrl, remoteThumb } = getMediaEntityData(mediaEntity)

    return { videoTitle, thumbnail, alt, uuid, url, videoUrl, remoteThumb }
  }

  function renderThumb() {
    return (
      Array.isArray(videos) &&
      videos.map((video, index) => {
        const {
          videoTitle, thumbnail, alt, uuid, videoUrl, remoteThumb 
        } = getVideoDataInfo(video)

        if (!isLoaded) {
          return ''
        }

        return isMobile ? (
          <div className="video-container" key={uuid}>
            <div className="image-container">
              <img
                src={thumbnail || remoteThumb}
                alt={alt || videoTitle}
                className={`img-fluid thumb-video`}
                onClick={() => {
                  setOpenImage(!openImage)
                  setStateVideoTitle(videoTitle)
                  setStateVideoUrl(videoUrl)
                }}
              />
              <span
                className="icon-play"
                onClick={() => {
                  setOpenImage(!openImage)
                  setStateVideoTitle(videoTitle)
                  setStateVideoUrl(videoUrl)
                }}
              >
                <img src={PlayIcon} alt="" />
              </span>
            </div>
            {videoTitle && (
              <div className="image-title">
                <span className="bar" />
                <Typography color="gray-100" className="title">
                  {videoTitle}
                </Typography>
              </div>
            )}
          </div>
        ) : (
          <Col sm={12} md={4} key={index + uuid} className={`${!isMobile ? 'd-flex' : ''}`}>
            <div className={`video-container mb-4 h-100 w-100 ${!isMobile ? 'd-flex flex-column' : ''}`}>
              <div className="image-container d-flex h-100">
                <img
                  src={thumbnail || remoteThumb}
                  alt={alt || videoTitle}
                  className="img-fluid thumb-video"
                  onClick={() => {
                    setOpenImage(!openImage)
                    setStateVideoTitle(videoTitle)
                    setStateVideoUrl(videoUrl)
                  }}
                />
                <span
                  className="icon-play"
                  onClick={() => {
                    setOpenImage(!openImage)
                    setStateVideoTitle(videoTitle)
                    setStateVideoUrl(videoUrl)
                  }}
                >
                  <img src={PlayIcon} alt="" />
                </span>
              </div>
              {videoTitle && (
                <div className="image-title">
                  <span className="bar" />
                  <Typography color="gray-100" className="title">
                    {videoTitle}
                  </Typography>
                </div>
              )}
            </div>
          </Col>
        )
      })
    )
  }

  return (
    <Container
      className={ClassNames('video-grid', themeClasses)}
      fluid
      style={{ backgroundColor: sectionBackgroundColor || 'var(--gray-400)' }}
    >
      <Container>
        {sectionTitle && (
          <Row>
            <Col sm={12}>
              <SectionTitle title={sectionTitle} className="mb-3" />
            </Col>
          </Row>
        )}

        {title && <Typography cssClass="video-grid-title mb-3">{title} </Typography>}

        {description && <div className="video-grid-description mb-5">{ReactHtmlParser(description)}</div>}

        {isMobile && isLoaded ? <Slider {...setting}>{renderThumb()}</Slider> : <Row>{renderThumb()}</Row>}

        <CustomModal
          open={openImage}
          closeModal={() => {
            setOpenImage(!openImage)
            setStateVideoTitle('')
            setStateVideoUrl('')
          }}
          title={stateVideoTitle}
          size={isMobile ? 'sm' : 'lg'}
          className="video-grid__modal"
        >
          <div className="w-100 h-100 pb-3 d-flex justify-content-center align-items-center">
            <iframe
              src={stateVideoUrl}
              title={stateVideoTitle}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </CustomModal>
      </Container>
    </Container>
  )
}

export default VideoGrid
